// extracted by mini-css-extract-plugin
export default {"title":"TopSection_title__6A2wZ","dateRow":"TopSection_dateRow__W--Ys"};